import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import hasInterface from '../../../../../hasInterface';
import MonotoneChain from './MonotoneChain';
import SweepLineEvent from './SweepLineEvent';
import EdgeSetIntersector from './EdgeSetIntersector';
import Collections from '../../../../../java/util/Collections';
import SegmentIntersector from './SegmentIntersector';
import ArrayList from '../../../../../java/util/ArrayList';
import List from '../../../../../java/util/List';
var SimpleMCSweepLineIntersector = /*#__PURE__*/function (_EdgeSetIntersector) {
  _inherits(SimpleMCSweepLineIntersector, _EdgeSetIntersector);
  function SimpleMCSweepLineIntersector() {
    var _this;
    _classCallCheck(this, SimpleMCSweepLineIntersector);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleMCSweepLineIntersector).call(this));
    SimpleMCSweepLineIntersector.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(SimpleMCSweepLineIntersector, [{
    key: "prepareEvents",
    value: function prepareEvents() {
      Collections.sort(this.events);
      for (var i = 0; i < this.events.size(); i++) {
        var ev = this.events.get(i);
        if (ev.isDelete()) ev.getInsertEvent().setDeleteEventIndex(i);
      }
    }
  }, {
    key: "computeIntersections",
    value: function computeIntersections() {
      if (arguments.length === 1) {
        var si = arguments[0];
        this.nOverlaps = 0;
        this.prepareEvents();
        for (var i = 0; i < this.events.size(); i++) {
          var ev = this.events.get(i);
          if (ev.isInsert()) this.processOverlaps(i, ev.getDeleteEventIndex(), ev, si);
          if (si.isDone()) break;
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof SegmentIntersector && hasInterface(arguments[0], List) && hasInterface(arguments[1], List)) {
          var edges0 = arguments[0],
            edges1 = arguments[1],
            _si = arguments[2];
          this.addEdges(edges0, edges0);
          this.addEdges(edges1, edges1);
          this.computeIntersections(_si);
        } else if (typeof arguments[2] === 'boolean' && hasInterface(arguments[0], List) && arguments[1] instanceof SegmentIntersector) {
          var edges = arguments[0],
            _si2 = arguments[1],
            testAllSegments = arguments[2];
          if (testAllSegments) this.addEdges(edges, null);else this.addEdges(edges);
          this.computeIntersections(_si2);
        }
      }
    }
  }, {
    key: "addEdge",
    value: function addEdge(edge, edgeSet) {
      var mce = edge.getMonotoneChainEdge();
      var startIndex = mce.getStartIndexes();
      for (var i = 0; i < startIndex.length - 1; i++) {
        var mc = new MonotoneChain(mce, i);
        var insertEvent = new SweepLineEvent(edgeSet, mce.getMinX(i), mc);
        this.events.add(insertEvent);
        this.events.add(new SweepLineEvent(mce.getMaxX(i), insertEvent));
      }
    }
  }, {
    key: "processOverlaps",
    value: function processOverlaps(start, end, ev0, si) {
      var mc0 = ev0.getObject();
      for (var i = start; i < end; i++) {
        var ev1 = this.events.get(i);
        if (ev1.isInsert()) {
          var mc1 = ev1.getObject();
          if (!ev0.isSameLabel(ev1)) {
            mc0.computeIntersections(mc1, si);
            this.nOverlaps++;
          }
        }
      }
    }
  }, {
    key: "addEdges",
    value: function addEdges() {
      if (arguments.length === 1) {
        var edges = arguments[0];
        for (var i = edges.iterator(); i.hasNext();) {
          var edge = i.next();
          this.addEdge(edge, edge);
        }
      } else if (arguments.length === 2) {
        var _edges = arguments[0],
          edgeSet = arguments[1];
        for (var _i = _edges.iterator(); _i.hasNext();) {
          var _edge = _i.next();
          this.addEdge(_edge, edgeSet);
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.events = new ArrayList();
      this.nOverlaps = null;
    }
  }]);
  return SimpleMCSweepLineIntersector;
}(EdgeSetIntersector);
export { SimpleMCSweepLineIntersector as default };